import usePageTitle from "@/hooks/usePageTitle";
import { Navigate, useLocation } from "react-router-dom";
import { useBirthdayGreetingConfigurationAccess, useConfigurationAccess } from "./access";

export default function ConfigurationIndexPage() {
  usePageTitle("/configuration", "Member 360 Configuration");
  const location = useLocation();
  const { loaded: configurationLoaded, canView: canViewGlobal } = useConfigurationAccess();
  const { loaded: birthdayAccessLoaded, canView: canViewBirthdayGreetings } = useBirthdayGreetingConfigurationAccess();
  const loaded = canViewGlobal ? configurationLoaded : birthdayAccessLoaded;

  if (!loaded) {
    return null;
  }

  // Global admins keep Career Consultants. Assigned consultants land on Birthday
  // Greetings. Department admins land on Interaction Topics. TabLayout still
  // denies anyone with none of those gates.
  const destination = canViewGlobal
    ? "career-consultants"
    : canViewBirthdayGreetings
      ? "birthday-greetings"
      : "interaction-topics";

  return <Navigate to={`${location.pathname}/${destination}`} replace />;
}
